// @flow
import * as React from 'react';

type Props = {
  src: string,
  title?: string
};

const Video = ({ src, title }: Props) => (
  <div>
    {src.includes('youtube.com/') || src.includes('youtu.be/') ? (
      <iframe
        width="560"
        height="315"
        src={src}
        frameBorder="0"
        allowFullScreen
        title={title}
      />
    ) : (
      <video src={src} controls preload="metadata">
        Sorry, your browser doesn't support embedded videos.
        <a href={src}>Download this video instead.</a>
      </video>
    )}
  </div>
);

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js